<template>
  <div
    class="post-preview post-preview--custom"
    :class="className"
    v-show="postId"
  >
    <div class="post-preview__inner" v-if="post">
      <div class="content-author__container">
        <a :href="post.memberPath" class="content-author__image"
          ><img :src="post.memberAvatar" alt=""
        /></a>
        <div class="content-author--oneline">
          <header>
            <a :href="post.memberPath" class="content-author__name">{{
              post.memberName
            }}</a>
            <div class="content-author__date">{{ post.createdAt }}</div>
          </header>
          <div class="discussion__content" v-html="post.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import discussionService from '../../../services/discussion_service'

  export default {
  name: "ReplyPreview",
  props: ["postId"],
  data () {
    return {
      post: null,
      className: ""
    };
  },
  mounted () {
    this.setPost(this.postId);
    window.addEventListener(
      "scroll",
      Grabcad.debounce(this.calculateHeights, 300)
    );
  },
  methods: {
    setPost (id) {
      if (id) {
        this.post = discussionService.getData(id);
        this.calculateHeights();
      }
    },
    calculateHeights () {
      setTimeout(() => {
        let distanceFromTop = this.$el.parentNode.getBoundingClientRect().top;
        let elementHeight =
          this.$el.scrollHeight ||
          this.$el.offsetHeight ||
          this.$el.scrollHeight;
        if (distanceFromTop - elementHeight < 0) {
          this.className = "to-bottom";
        } else {
          this.className = "";
        }
      }, 0);
    }
  },
  watch: {
    postId (newValue) {
      this.setPost(newValue);
    }
  }
};
</script>
